<template>
  <div
    class="introducing relative bg-[#FFF] overflow-hidden flex items-center justify-center px-4 py-[30px] lg:py-[80px]"
  >
    <div
      class="w-full max-w-[1064px] mx-auto flex justify-center items-center lg:items-end flex-col lg:flex-row gap-10"
    >
      <div class="w-[300px] h-[350px] overflow-hidden rounded-xl shrink-0">
        <img
          class="object-cover w-full h-full"
          src="@/assets/self-potrait.jpg"
          alt="introducing"
        />
      </div>
      <div class="mt-4 lg:mt-0">
        <p
          class="poppins capitalize font-semibold text-[#F44F1A] text-[48.83px] lg:text-[61.04px] leading-[100%]"
        >
          Hi!
        </p>
        <p
          class="nunito font-normal text-[#333] text-[16px] lg:text-2xl mt-4 lg:mt-8"
        >
          My name is
          <span class="text-[#F44F1A] font-bold">Muhammad Akmal Beliuk.</span>
        </p>
        <p
          class="poppins font-normal text-[#333] text-[16px] lg:text-md text-justify mt-4 lg:mt-4 w-full max-w-[600px]"
        >
          I'm someone who finds joy in building things — especially websites
          that not only work well, but also look great and feel right. With a
          background in Informatics Engineering, I’ve always been curious about
          how design and technology can come together to tell stories, solve
          problems, and create impact. Outside of coding, I enjoy learning new
          things, collaborating with others, and pushing myself to grow — both
          as a developer and as a person.
        </p>
      </div>
    </div>
    <!-- <div
      class="mx-4 md:mx-7 lg:mx-auto lg:max-w-[1064px] h-full flex justify-center items-center flex-col"
    >
    </div> -->
  </div>
</template>
